import { supabase } from '../supabaseClient';

/* A landing (web3kurzus.hu) megnyitása a bejelentkezett munkamenettel.
   Ugyanaz a formátum, mint a terminálé (crypto-terminal src/utils/landing.js):
   a tokenek a HASH-ben mennek (#w3k_handoff=1&w3k_at=…&w3k_rt=…), nem query
   paraméterben, így nem kerülnek szervernaplóba; a landing useSessionHandoff()
   a /dashboard és a /pro oldalon veszi át, és azonnal kitakarítja a címsort.
   Ugyanabban a lapon nyit (nincs popup-blokkoló gond). */
export const LANDING_URL = 'https://web3kurzus.hu';

/* A cél-horgony (pl. '/plusz#arak') munkamenettel w3k_anchor-ként megy, mert a
   hash a tokeneké; a landing a takarítás után visszaírja (sessionHandoff.js). */
export const PLUSZ_PATH = '/plusz#arak';

export const TERMINAL_URL = 'https://terminal.web3kurzus.hu';

async function openWithSession(base, path) {
  let url = `${base}${path}`;
  try {
    const { data } = await supabase.auth.getSession();
    const s = data?.session;
    if (s?.access_token && s?.refresh_token) {
      const [bare, anchor] = path.split('#');
      url = `${base}${bare}#${new URLSearchParams({
        w3k_handoff: '1', w3k_at: s.access_token, w3k_rt: s.refresh_token, ...(anchor ? { w3k_anchor: anchor } : {}),
      }).toString()}`;
    }
  } catch { /* munkamenet nélkül is megnyílik: ott a belépés jön */ }
  window.location.href = url;
}

/* A landing egy oldala (a /dashboard, /segedletek, /plusz, /pro veszi át a munkamenetet). */
export function openLanding(path) { return openWithSession(LANDING_URL, path); }

/* Navigáció 1: a Kripto Terminál ugyanígy (a terminál handoffCapture.js-e minden útvonalon átveszi). */
export function openTerminal(path = '/') { return openWithSession(TERMINAL_URL, path); }
